import { Injectable, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { LocaleService } from '@next/core-lib/i18n';

@Injectable()
export class I18nPaginatorAdapter extends MatPaginatorIntl {
  private readonly locale = inject(LocaleService);

  itemsPerPageLabel = this.locale.translate('paginator.items_per_page');
  firstPageLabel = this.locale.translate('paginator.first_page');
  lastPageLabel = this.locale.translate('paginator.last_page');
  nextPageLabel = this.locale.translate('paginator.next');
  previousPageLabel = this.locale.translate('paginator.previous');

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    super();
  }

  getRangeLabel: (page: number, pageSize: number, length: number) => string = (
    page: number,
    pageSize: number,
    length: number,
  ) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.locale.translate('paginator.of')} ${length}`;
    }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex =
      startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return `${startIndex + 1} – ${endIndex} ${this.locale.translate('paginator.of')} ${length}`;
  };
}
